export type UIConfigurationsGlobalState = {
  dashboardUIConfigurationId: number | null;
  patientOverviewUIConfigurationId: number | null;
  patientListConfigurationId: number | null;
  calendarConfigurationId: number | null;
};

export const defaultUIConfigurationsGlobalState: UIConfigurationsGlobalState = {
  dashboardUIConfigurationId: null,
  patientOverviewUIConfigurationId: null,
  patientListConfigurationId: null,
  calendarConfigurationId: null,
};
